<template>
    <v-dialog max-width="60%" @click:outside="cancel" @keyup.esc="cancel">
        <v-card>
            <v-card-title class="text-h5 bg-grey-lighten-2" primary-title style="display: relative">
                Data QC Detail
            </v-card-title>
            <v-card-text>
                <summary-per-task-measurements-list
                    v-if="taskSchedule != null"
                    :protocol="schemaConfig"
                    :taskSchedule="taskSchedule"
                    :dataCollectionTask="dataCollectionTask"
                    :taskGroup="taskGroup"
                    :experiment="experiment"
                />
                <v-form class="pt-8" style="display: flex">
                    <v-container>
                        <v-row>
                            <v-col cols="4">
                                <v-autocomplete
                                    :items="[
                                        'Contact CRO',
                                        'Data Overdue',
                                        'Missing Data',
                                        'Confirm QC',
                                        'Confirm QC with Error',
                                        'Looker Flag',
                                        'Canceled',
                                        'Not Collected',
                                    ]"
                                    label="QC Status"
                                    :readonly="!canManageQC"
                                    v-model="localQcItem.status"
                                    :error-messages="
                                        commentsRequired
                                            ? ['Comments are required for this status']
                                            : []
                                    "
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-textarea
                                    v-model="localQcItem.comments"
                                    label="Data Notes"
                                    variant="outlined"
                                    :readonly="!canManageQC"
                                    rows="4"
                                />
                            </v-col>
                            <v-col cols="4">
                                <v-textarea
                                    v-model="localQcItem.investigator_comments"
                                    label="Investigator Comments"
                                    variant="outlined"
                                    rows="4"
                                />
                            </v-col>
                        </v-row>
                    </v-container>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="save" :disabled="!isFormValid"> Save Changes </v-btn>
                <v-btn color="primary" @click="cancel"> Cancel </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { defineComponent } from "vue";
import { measurementsAPI } from "@/services/api.services";
import SummaryPerTaskMeasurementsList from "../Measurements/SummaryPerTaskMeasurementsList.vue";
import { buildTaskScheduleHelper } from "@/lib/taskUtils";
import { mapGetters } from "vuex";

export default defineComponent({
    components: {
        SummaryPerTaskMeasurementsList,
    },

    created() {
        this.taskScheduleHelper = buildTaskScheduleHelper(this.taskSchedule);
        this.taskGroup = this.taskScheduleHelper.getTaskGroupById(
            this.dataCollectionTask.taskGroupId
        );

        // Initialize localQcItem to avoid directly mutating the prop
        this.localQcItem = { ...this.qcItem };
    },

    methods: {
        cancel() {
            this.$emit("cancel");
        },
        async save() {
            const qcStatusUpdate = {
                status: this.localQcItem.status,
                comments: this.localQcItem.comments,
                investigator_comments: this.localQcItem.investigator_comments,
            };
            await measurementsAPI.updateQCStatus(this.dataCollectionTask.id, qcStatusUpdate);
            this.$emit("save");
        },
    },

    computed: {
        ...mapGetters(["isAuthorizedForOneOf"]),
        isFormValid() {
            if (this.commentsRequired) {
                return false;
            }
            return this.localQcItem.status;
        },
        commentsRequired() {
            return (
                (this.localQcItem.status === "Confirm QC with Error" ||
                    this.localQcItem.status === "Looker Flag") &&
                !this.localQcItem.comments
            );
        },
        canManageQC() {
            return this.isAuthorizedForOneOf("DataQC:Create");
        },
    },

    props: {
        qcItem: {
            type: Object,
            required: true,
        },
        schemaConfig: {
            type: Object,
            required: true,
        },
        taskSchedule: {
            type: Object,
            required: true,
        },
        dataCollectionTask: {
            type: Object,
            required: true,
        },
        experiment: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            taskScheduleHelper: null,
            taskGroup: null,
            localQcItem: null, // Add localQcItem to data
        };
    },
});
</script>
<style></style>
